import React from 'react';
import { Link } from 'react-router-dom';
import { getAPIUrl, getLabelClassName, getUrlPrefix } from './utils';
import { GlobalSpinner, ListingFooter, ListingHeader, NoResultsFound, SortableHeader, usePaginatedSearchWithSorting } from '../widgets';
function TableRow({ name, number, numberSlug, type }) {
    const url = `${getUrlPrefix()}d/${numberSlug}/`;
    return (React.createElement("tr", null,
        React.createElement("td", null, name ? (React.createElement(Link, { to: url }, name)) : ''),
        React.createElement("td", null, number ? (React.createElement(Link, { to: url }, number)) : ''),
        React.createElement("td", null,
            React.createElement("span", { className: getLabelClassName(type) }, type || ''))));
}
function Table({ entries, currentDir, currentKey, handleSorting }) {
    const sortKeys = [
        { sortKey: 'name', label: 'Name' },
        { sortKey: 'number', label: 'Number' },
        { sortKey: 'type', label: 'Procurement Type' },
    ];
    function renderRows() {
        return entries.map(entry => (React.createElement(TableRow, { key: entry.id, name: entry.name, number: entry.number, numberSlug: entry.numberSlug, type: entry.type })));
    }
    return (React.createElement("div", { className: "table-responsive" },
        React.createElement("table", { className: "table table-striped" },
            React.createElement("thead", null,
                React.createElement("tr", null, sortKeys.map(el => (React.createElement(SortableHeader, { key: `sortable-header-${el.sortKey}`, handleSorting: handleSorting, currentKey: currentKey, currentDir: currentDir, sortKey: el.sortKey, label: el.label }))))),
            React.createElement("tbody", null, renderRows()))));
}
export function ListingUI() {
    const [{ firstLoad, entries, currentPage, perPage, totalPages, searchStrVisible, searchStr, sortKey, sortDir, totalEntries }, { changePage, handleSearchChange, handleSorting, resetSearch, }] = usePaginatedSearchWithSorting(getAPIUrl());
    if (firstLoad) {
        return (React.createElement(React.Fragment, null,
            React.createElement(GlobalSpinner, { display: firstLoad })));
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "p-3 align-self-start flex-grow-1 container-fluid", id: "procurements-listing" },
            React.createElement(ListingHeader, { searchStr: searchStrVisible, handleSearchChange: handleSearchChange }),
            entries.length > 0 && (React.createElement(React.Fragment, null,
                React.createElement(Table, { handleSorting: handleSorting, entries: entries, currentKey: sortKey, currentDir: sortDir }),
                React.createElement(ListingFooter, { changePage: changePage, isSearch: searchStr !== '', currentPage: currentPage, perPage: perPage, totalEntries: totalEntries, totalPages: totalPages }))),
            React.createElement(NoResultsFound, { searchStr: searchStrVisible, hasEntries: entries.length > 0, resetSearch: resetSearch }))));
}
